import PropTypes from "prop-types";
import React from "react";
import { useDispatch } from "react-redux";
import { Modal, ModalBody } from "reactstrap";
import { customDelete } from "@helpers/custom-delete/controller/delete-service.js";
const DeleteModal = ({ show, onCloseClick, data }) => {
  const dispatch = useDispatch();
  const handleDelete = async (data) => {
    try {
      await dispatch(
        customDelete({ id: data.id, url: data.url, data: data })
      ).unwrap();
      onCloseClick();
    } catch (error) {
      console.error("Failed to delete the data:", error);
    }
  };
  return (
    <Modal size="md" isOpen={show} toggle={onCloseClick} centered={true}>
      <div className="modal-content">
        <ModalBody className="px-4 py-5 text-center">
          <button
            type="button"
            className="btn-close position-absolute end-0 top-0 m-3"
            onClick={onCloseClick}
          ></button>
          <div className="avatar-sm mb-4 mx-auto">
            <div className="avatar-title bg-primary text-primary bg-opacity-10 font-size-20 rounded-3">
              <i className="mdi mdi-trash-can-outline"></i>
            </div>
          </div>
          <p className="text-muted font-size-16 mb-4">
            Are you sure you want to {!data.deleted_at ? "delete" : "restore"}{" "}
            the data
          </p>

          <div className="hstack gap-2 justify-content-center mb-0">
            <button
              type="button"
              className={
                !data.deleted_at ? "btn btn-danger" : "btn btn-success"
              }
              onClick={() => handleDelete(data)}
            >
              {!data.deleted_at ? "Delete" : "Restore"}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onCloseClick}
            >
              Close
            </button>
          </div>
        </ModalBody>
      </div>
    </Modal>
  );
};

DeleteModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any,
  data: PropTypes.any,
};

export default DeleteModal;
